import React, { ComponentType } from "react";

import TableSkeletonLoader from "components/Progress/TableSkeletonLoader";
import SuspendedComponent from "components/SuspendedComponent/SuspendedComponent";

import { lazyRetry } from "./pages";

// Type-safe lazy loading wrapper
export function CreateSuspendedComponent<T extends ComponentType<any>>(
  importFunc: () => Promise<{ default: T }>,
  useRetry = true,
  FallBack: NonNullable<React.ReactNode> | undefined = <TableSkeletonLoader />,
): T {
  const LazyComponent = useRetry
    ? React.lazy(() => lazyRetry(importFunc))
    : React.lazy(importFunc);

  const Component = SuspendedComponent(LazyComponent, FallBack);
  return Component as unknown as T;
}

export default CreateSuspendedComponent;
